<template>
  <div id="app">
    <router-view/>

    <GlobalNotification/>
    <GlobalLoading/>
  </div>
</template>

<script>
import GlobalNotification from './components/GlobalNotification.vue';
import GlobalLoading from './components/GlobalLoading.vue';

export default {
  name: 'App',
  components: {
    GlobalNotification,
    GlobalLoading,
  },
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

#app {
  font-family: var(--mank-font-family);
  color: var(--mank-text-primary);
  height: 100%;
}

body,
.v-application {
  color: var(--mank-text-primary) !important;
}

.v-application .text--primary {
  color: var(--mank-text-primary) !important;
  caret-color: var(--mank-text-primary) !important;
}

.v-application .text--secondary {
  color: var(--mank-text-secondary) !important;
  caret-color: var(--mank-text-secondary) !important;
}
</style>
